import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { ModalDeleteComponent } from 'src/app/utils/modal-delete/modal-delete.component';
import { SentryService } from 'src/app/utils/sentry/sentry.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
import { SuscripcionesInformacionPlanesComponent } from '../suscripciones-informacion-planes/suscripciones-informacion-planes.component';
import { SuscripcionesService } from '../suscripciones.service';
import { SuscripcionesPagoPendienteComponent } from '../suscripciones-pago-pendiente/suscripciones-pago-pendiente.component';
import { Router } from '@angular/router';
import { ModalContactoSoporteComponent } from 'src/app/shared/contacto-soporte/contacto-soporte.component';

@Component({
  selector: 'app-suscripciones-trial-expirado',
  templateUrl: './suscripciones-trial-expirado.component.html',
  styleUrls: ['./suscripciones-trial-expirado.component.scss']
})
export class SuscripcionesTrialExpiradoComponent implements OnInit {

  infoPlan = {
    nombre: '',
    inicio_suscripcion: null,
    siguiente_pago: null,
    fecha_fin_trial: null,
    app_habilitada: false,
    monto: 0,
    brand_name: null,
    last4: null,
  };

  constructor(
    private sesion: SesionService,
    private modalService: NgbModal,
    private suscripcionesService: SuscripcionesService,
    private loading: LoadingService,
    private alerts: AlertService,
    private sentryService: SentryService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    if (this.sesion.redirectToSuscripcionExpirada) {
      this.miSuscripcion();
    } else {
      this.checkPaymentState();
    }
  }

  get esCuentaPrueba(): boolean {
    return this.sesion.user.cuenta_prueba;
  }

  get esAdmin(): boolean {
    return this.sesion.esAdmin;
  }

  contactoVentas(): void {
    const modalRef = this.modalService.open(SuscripcionesPagoPendienteComponent, { centered: true, backdrop: 'static' });
    modalRef.result.then((result: any) => {
      if (result.cerrarSesion) {
        this.logout();
      }
    }, (reason: any) => { });
  }

  contactoSoporte(): void {
    const modalRef = this.modalService.open(ModalContactoSoporteComponent, { windowClass: 'clear-modal', size: 's', scrollable: true, centered: true });
    modalRef.componentInstance.soloDemo = this.sesion.user.cuenta_prueba;
    modalRef.componentInstance.showTutorialButton = false;
    modalRef.result.then((result: any) => {
    }, (reason: any) => { });
  }

  logout(): void {
    this.loading.show();
    this.sesion.clearSesion();
    this.loading.hide();
    this.router.navigate(['login']);
    this.sentryService.setUser(null, null);
  }

  async realizarPagoPremium() {
    this.loading.show();
    let suscripcion_activa = await this.sesion.obtenerEstadoSuscripcion();
    this.loading.hide();
    if (suscripcion_activa) {
      const modalRef = this.modalService.open(ModalDeleteComponent, { size: 'lg', scrollable: true, centered: true });
      this.sesion.redirectToSuscripcionExpirada = false;
      modalRef.componentInstance.texto = 'Ya posee una suscripción activa.';
      modalRef.componentInstance.textoAceptar = 'Aceptar';
      modalRef.result.then((result: any) => { }, (reason: any) => { });
      return;
    }
    this.loading.show();
    this.suscripcionesService.planActual().subscribe({
      next: (res: any) => {
        this.loading.hide();
        const modalRef = this.modalService.open(SuscripcionesInformacionPlanesComponent, { size: 'xl', scrollable: true, centered: true, backdrop: 'static' });
        modalRef.componentInstance.suscripcionPrevia = res.suscripcion;
        modalRef.componentInstance.suscripcionVPPrevia = res.suscripcionVP;
        modalRef.componentInstance.suscripcionDLGPrevia = res.suscripcionDLG;
        modalRef.result.then((result: any) => { }, (reason: any) => { });
      },
      error: (err: any) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("Error al obtener la información.", "danger");
        this.sentryService.captureException(err.error);
      }
    });
  }

  miSuscripcion(): void {
    this.sesion.miSuscripcion().subscribe({
      next: (res: any) => {
        this.infoPlan = res;
      },
      error: (err: any) => {
        console.error(err);
        this.sentryService.captureException(err.error);
      }
    });
  }

  checkPaymentState(): void {
    this.loading.show();
    this.sesion.getPaymentState().subscribe({
      next: (res: any) => {
        this.loading.hide();
        if (res.suscripcion_activa || this.sesion.usuario.rol_id === 0) {
          this.sesion.redirectToSuscripcionExpirada = false;
          this.sesion.goToHome();
        } else {
          this.miSuscripcion();
        }
      },
      error: (err: any) => {
        console.error(err);
        this.loading.hide();
        if (err.response) this.alerts.addAlert(err.response, 'danger');
      }
    });
  }
}
